import React from 'react';

import { Box } from '@rbilabs/universal-components';

import { useProductCalories } from 'pages/menu/components/product-wizard/use-product-calories';
import { useProductTotalPrice } from 'pages/menu/components/product-wizard/use-product-total-price';

import { useProductWizardContext } from '../../product-wizard';
import { useProductWizardFlow } from '../../product-wizard/use-product-wizard-flow';

import { OverSodiumLimitWarning } from './over-sodium-limit-warning';
import { ProductPriceCaloriesContainer, ProductPriceCaloriesText } from './styled';

interface ProductPriceCaloriesProps {
  showPlusSign?: boolean;
}

export const ProductPriceCalories = ({ showPlusSign }: ProductPriceCaloriesProps) => {
  const { selectedProduct, slotsSelections, productQuantity } = useProductWizardContext();
  const { cartIdEditing, id, rewardId } = useProductWizardFlow();
  const { formattedTotalPrice } = useProductTotalPrice({
    id,
    selectedProduct,
    slotsSelections,
    productQuantity,
    cartIdEditing,
    rewardId,
  });
  const calories = useProductCalories(selectedProduct);

  const accessibilityLabel = `${formattedTotalPrice} ${calories}`;

  return (
    <Box focusable accessibilityLabel={accessibilityLabel}>
      <ProductPriceCaloriesContainer>
        <ProductPriceCaloriesText>
          {formattedTotalPrice && (
            <Box testID="product-total-price" fontWeight={'bold'}>
              {formattedTotalPrice}
            </Box>
          )}
          {formattedTotalPrice && calories && <Box alignSelf={'center'}>{' | '}</Box>}
          {calories && <Box testID="product-total-calories">{calories}</Box>}
        </ProductPriceCaloriesText>
        <OverSodiumLimitWarning />
      </ProductPriceCaloriesContainer>
    </Box>
  );
};
